import React from "react";
import { IconProps } from "types/v2/common/IconProps";
import { getTheme } from "utils/v2/theme";

const ArrowRightIcon: React.FC<IconProps> = ({ onClick }) => {
  const color = getTheme() === "dark" ? "#BDBDBD" : "#626262";

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M0 9L12.17 9L6.58 14.59L8 16L16 8L8 0L6.59 1.41L12.17 7L0 7V9Z"
        fill={color}
      />
    </svg>
  );
};
export default ArrowRightIcon;
